// extracted by mini-css-extract-plugin
export default {"container":"Page404_container__JL9F4","logo":"Page404_logo__mUx+T","primary":"Page404_primary__DNLBW"};